{
    "environmentBlocks": {
        "atlassian-analytics": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "bitbucket": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "chat": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "confluence": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {
                "ccma": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-anonymous-access": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-comment-and-header-links": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-company-hub": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-content-archiving": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-content-manager": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-databases": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": false
                    }
                },
                "confluence-editing-experience": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-employee-directory": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-inline-comments-in-edit-mode": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-inspect-permissions": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-loom-integration": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-mission-control": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-mobile-app": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-page-analytics": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-pages-blogs-folders": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-presenter-mode": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-public-links": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-questions": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-search": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-single-space-guests": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-slack-integration": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-smart-links": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-space-analytics": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-update-page-owners": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "confluence-whiteboards": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                }
            }
        },
        "goals": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "guard-premium": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "guard-standard": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "home": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {
                "home-status-backend": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                }
            }
        },
        "jira": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {
                "jcma": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-admin-site-optimiser": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-atlassian-intelligence": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-atlassian-vs-code-extension": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-audit-log": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-backlogs": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-board-and-backlog-insights": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-boards-and-views": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-calendar-view": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-company-managed-projects": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-components-company-only": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-forms": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-github-for-jira": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-github-workflows": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-in-product-help": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-mobile-app": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-plans": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-project-archiving": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-project-issue-navigator": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-project-templates": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-releases": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-slack": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-smart-links": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-team-managed-projects": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-work-item-archiving": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-workflow-configuration": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-your-work-dashboard": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                }
            }
        },
        "jira-align": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "jira-product-discovery": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "jira-service-desk": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "jira-service-management": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {
                "jira-service-management-ai-ops": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-service-management-assets": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-service-management-chat-ops": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-service-management-chat": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-service-management-csm-functionality": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-service-management-deployment-gating": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-service-management-deployment-tracking": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": false
                    }
                },
                "jira-service-management-embeddable-widget": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-service-management-err-governance-api": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-service-management-help-center": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-service-management-incident-conference-calls": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-service-management-incident-management-integration": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-service-management-ops-genie-reporting": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jira-service-management-virtual-service-agent": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-alert-notifications": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-approvals": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-canned-responses": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-change-calendar": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-change-risk-assessment": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-csat": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-customer-notifications": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-forms": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-knowledge-base": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-multi-language-support": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-on-call-schedule": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-portal-only-account-scim": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-post-incident-reviews": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-queues": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-services": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-sla-management": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "jsm-templates-and-views": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                }
            }
        },
        "jira-software": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "loom": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "projects": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "rovo": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {
                "rovo-ai-3p-connections": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "rovo-ai-app-availability": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "rovo-ai-atlassian-intelligence-app-availability": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "rovo-ai-generative-ai-editor": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "rovo-ai-machine-learning": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "rovo-ai-natural-language-in-automation-rule-creation": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "rovo-ai-projects": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "rovo-ai-smart-features-based-on-machine-learning-tecton-ai": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                }
            }
        },
        "search": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "studio": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "teams": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": false,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "trello": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "adminhub": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {
                "adminhub-access-requests": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-actor-profiles": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-admin-insights": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-alert-dashboard": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-alert-details": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-alert-messaging-integrations": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-api-token-controls": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-app-requests": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-app-updates": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-application-tunnels": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-audit-log": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-authentication-policies": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-automatic-product-discovery": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-billing-console": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-brie": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-byok": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-content-scanning": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-custom-domains": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-custom-email-addresses": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-data-classifications": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-data-residency": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-data-security-policies": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-discovered-apps": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-dlp-partner-integrations": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-enforced-2-step-verification": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-enforced-data-security-policy-by-classification": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-experiment-controls": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-hippa-compliance": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-last-active-date": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-mobile-app-policy": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-multiple-idps": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-org-audit-logs": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-org-deletion": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-org-transfer": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-release-tracks": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-remediation-api": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-remediation-recommendations": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-remediation-workflows": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-saml-sso": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-sandbox": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-self-service-product-acquisition": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-siem-integrations": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-url-subdomain-updates": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-user-access-settings": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-user-counts": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-user-impersonation": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "adminhub-user-provisioning": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                }
            }
        },
        "anti-abuse-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "atlassian-visualization-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {
                "atlassian-visualization-platform-kamino": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "atlassian-visualization-platform-manifold": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "atlassian-visualization-platform-plato": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                }
            }
        },
        "collaboration-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "commerce-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {
                "commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "commerce-platform-self-serve": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                }
            }
        },
        "cross-product-search": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "ecosystem-forge": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {
                "ecosystem-oauth": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "forge-cli": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "forge-remote-capabilities": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "forge-storage-service-rockmelon": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "forge-system-apps": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "forge": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                }
            }
        },
        "growth-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "identity": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {
                "identity-virality": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                }
            }
        },
        "machine-learning-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "marketplace": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {
                "marketplace-app-discovery": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "marketplace-app-migrations": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "marketplace-atlassian-labs": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "marketplace-audit-logs": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "marketplace-self-service-purchase-provision-install": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                }
            }
        },
        "migrations": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {
                "c2c-migrations": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "commercial-cloud-to-agc": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "data-center-to-agc": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                }
            }
        },
        "migrations-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "post-office": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "product-integrations-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "reactions": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "smartlinks": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "analytics-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "atlassian-graphql-gateway": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "automation-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {
                "automation-platform-actions": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "automation-platform-automation-templates": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "automation-platform-branches": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "automation-platform-conditions": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "automation-platform-natural-language-rule-builder": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "automation-platform-rule-builder": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "automation-platform-templates": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": true,
                        "isolated-commercial-cloud-ga": true
                    }
                },
                "automation-platform-triggers": {
                    "compositions": {
                        "commercial-cloud": true,
                        "fedramp-moderate": false,
                        "isolated-commercial-cloud-ga": true
                    }
                }
            }
        },
        "bifrost": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "core-network-automation": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "data-access-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "data-classification-governance-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "data-depot-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "data-exchange-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "data-management-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "data-movement-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "data-platform-services": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "decisions-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "edge": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "infrastructure": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "internal-edge": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "job-execution-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "mail-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "media-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "networking": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "pollinator": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "streamhub": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "targeting-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "tdp-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "teamwork-graph-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "tenant-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        },
        "testing-platform": {
            "compositions": {
                "commercial-cloud": true,
                "fedramp-moderate": true,
                "isolated-commercial-cloud-ga": true
            },
            "features": {}
        }
    }
}
